import React from 'react';
import { LogisticsObjectDetailPage } from '@/components/common/LogisticsObjectDetailPage';

const HumanMeanDetailPage: React.FC = () => {
  return (
    <LogisticsObjectDetailPage
      config={{
        logisticsObjectType: 'human-mean',
        routeParamKey: 'humanMeanId',
        pageTitle: 'HumanMean Details',
        backRoute: '/human-means',
        backLabel: 'Back to HumanMeans',
        tabIdPrefix: 'human-mean',
        tabsAriaLabel: 'human-mean detail tabs',
        missingIdMessage: 'No human-mean ID provided in the URL.',
        noDataMessage: 'No human-mean data available. The human-mean might not exist or you may not have permission to view it.',
      }}
    />
  );
};

export default HumanMeanDetailPage;
